import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';

// Component for app-ads.txt page
function AppAdsPage() {
  return (
    <div style={{
      backgroundColor: 'white',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      padding: 20
    }}>
      <div style={{
        color: 'black',
        fontSize: '16px',
        fontFamily: 'monospace',
        textAlign: 'center'
      }}>
        google.com, pub-2873376619277640, DIRECT, f08c47fec0942fa0
      </div>
    </div>
  );
}

// Main home component
function HomePage() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppAdsPage />} />
        <Route path="/app-ads.txt" element={<AppAdsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
